/**
 * Generated from ch7_p07.fla
 */
export function ch7_p07(this: Ich7_p07) {
	const sheep = this.sheep;
	if (!sheep[0] && sheep.elementFactory) {
		sheep[0] = sheep.elementFactory(0,undefined);
	}
	if (sheep[0]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep1.call(sheep[0] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep1);
		sheep[0].x = 990.25;
		sheep[0].y = 560.5;
		sheep[0].width = 196.50;
		sheep[0].height = 142.50;
		sheep[0].alpha = 1;
		if (sheep[0].onLayout) sheep[0].onLayout();
	}
	if (!sheep[1] && sheep.elementFactory) {
		sheep[1] = sheep.elementFactory(1,undefined);
	}
	if (sheep[1]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep2.call(sheep[1] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep2);
		sheep[1].x = 1214.2;
		sheep[1].y = 637.5;
		sheep[1].width = 208.50;
		sheep[1].height = 165.00;
		sheep[1].alpha = 1;
		if (sheep[1].onLayout) sheep[1].onLayout();
	}
	if (!sheep[2] && sheep.elementFactory) {
		sheep[2] = sheep.elementFactory(2,undefined);
	}
	if (sheep[2]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep3.call(sheep[2] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep3);
		sheep[2].x = 1164.7;
		sheep[2].y = 749.5;
		sheep[2].width = 251.50;
		sheep[2].height = 176.00;
		sheep[2].alpha = 1;
		if (sheep[2].onLayout) sheep[2].onLayout();
	}
	const apple = this.apple;
	if (!apple[0] && apple.elementFactory) {
		apple[0] = apple.elementFactory(0,undefined);
	}
	if (apple[0]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4.call(apple[0] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4);
		apple[0].x = 547.5;
		apple[0].y = 658.75;
		apple[0].width = 64.00;
		apple[0].height = 77.50;
		apple[0].alpha = 1;
		if (apple[0].onLayout) apple[0].onLayout();
	}
	if (!apple[1] && apple.elementFactory) {
		apple[1] = apple.elementFactory(1,undefined);
	}
	if (apple[1]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3.call(apple[1] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3);
		apple[1].x = 497.5;
		apple[1].y = 639;
		apple[1].width = 75.00;
		apple[1].height = 75.00;
		apple[1].alpha = 1;
		if (apple[1].onLayout) apple[1].onLayout();
	}
	if (!apple[2] && apple.elementFactory) {
		apple[2] = apple.elementFactory(2,undefined);
	}
	if (apple[2]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2.call(apple[2] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2);
		apple[2].x = 513;
		apple[2].y = 704;
		apple[2].width = 75.00;
		apple[2].height = 75.00;
		apple[2].alpha = 1;
		if (apple[2].onLayout) apple[2].onLayout();
	}
	if (!apple[3] && apple.elementFactory) {
		apple[3] = apple.elementFactory(3,undefined);
	}
	if (apple[3]) {
		ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1.call(apple[3] as Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1);
		apple[3].x = 446;
		apple[3].y = 661;
		apple[3].width = 64.00;
		apple[3].height = 77.00;
		apple[3].alpha = 1;
		if (apple[3].onLayout) apple[3].onLayout();
	}
	const appleTarget = this.appleTarget;
	if (!appleTarget[0] && appleTarget.elementFactory) {
		appleTarget[0] = appleTarget.elementFactory(0,undefined);
	}
	if (appleTarget[0]) {
		ch7_p07_appleTarget.call(appleTarget[0] as Ich7_p07_appleTarget);
		appleTarget[0].x = 733.65;
		appleTarget[0].y = 579.15;
		appleTarget[0].width = 300.00;
		appleTarget[0].height = 300.00;
		if (appleTarget[0].onLayout) appleTarget[0].onLayout();
	}
	if (!appleTarget[1] && appleTarget.elementFactory) {
		appleTarget[1] = appleTarget.elementFactory(1,undefined);
	}
	if (appleTarget[1]) {
		ch7_p07_appleTarget.call(appleTarget[1] as Ich7_p07_appleTarget);
		appleTarget[1].x = 493;
		appleTarget[1].y = 468.15;
		appleTarget[1].width = 300.00;
		appleTarget[1].height = 300.00;
		if (appleTarget[1].onLayout) appleTarget[1].onLayout();
	}
	const bg = this.bg;
	ch7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const gateOpen = this.gateOpen;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_opengate.call(this.gateOpen);
	gateOpen.x = 728.25;
	gateOpen.y = 417.25;
	gateOpen.width = 183.50;
	gateOpen.height = 110.50;
	gateOpen.alpha = 1.00;
	if (gateOpen.onLayout) gateOpen.onLayout();
	const gateClosed = this.gateClosed;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_closedgate.call(this.gateClosed);
	gateClosed.x = 538.5;
	gateClosed.y = 431.25;
	gateClosed.width = 234.00;
	gateClosed.height = 151.50;
	gateClosed.alpha = 1.00;
	if (gateClosed.onLayout) gateClosed.onLayout();
	const table = this.table;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_taable.call(this.table);
	table.x = 1327.25;
	table.y = 569;
	table.width = 308.50;
	table.height = 145.00;
	table.alpha = 1.00;
	if (table.onLayout) table.onLayout();
	const sheepSizeReference = this.sheepSizeReference;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetSheepsizewhenenteringgate.call(this.sheepSizeReference);
	sheepSizeReference.x = 510.25;
	sheepSizeReference.y = 491.5;
	sheepSizeReference.width = 136.50;
	sheepSizeReference.height = 99.50;
	sheepSizeReference.alpha = 1.00;
	if (sheepSizeReference.onLayout) sheepSizeReference.onLayout();
	const penFront = this.penFront;
	ch7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_penfront.call(this.penFront);
	penFront.x = 228.75;
	penFront.y = 421;
	penFront.width = 457.50;
	penFront.height = 121.00;
	penFront.alpha = 1.00;
	if (penFront.onLayout) penFront.onLayout();
	const holly = this.holly;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_holly.call(this.holly);
	holly.x = 550.5;
	holly.y = 668.5;
	holly.width = 139.00;
	holly.height = 338.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const satchelBack = this.satchelBack;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelback.call(this.satchelBack);
	satchelBack.x = 510.25;
	satchelBack.y = 690.25;
	satchelBack.width = 340.50;
	satchelBack.height = 155.50;
	satchelBack.alpha = 1.00;
	if (satchelBack.onLayout) satchelBack.onLayout();
	const satchelFront = this.satchelFront;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelfront.call(this.satchelFront);
	satchelFront.x = 520.25;
	satchelFront.y = 717.75;
	satchelFront.width = 320.50;
	satchelFront.height = 100.50;
	satchelFront.alpha = 1.00;
	if (satchelFront.onLayout) satchelFront.onLayout();
	const frameRight = this.frameRight;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 263.25;
	linesRight.width = 113.00;
	linesRight.height = 526.50;
	linesRight.alpha = 0.50;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 343.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 462.5;
	linesLeft.width = 117.50;
	linesLeft.height = 162.00;
	linesLeft.alpha = 0.50;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_bg(this: Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_opengate(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_opengate) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_opengate", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_closedgate(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_closedgate) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_closedgate", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_taable(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_taable) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_taable", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetSheepsizewhenenteringgate(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetSheepsizewhenenteringgate) {
	if (this.setLayoutTexture) this.setLayoutTexture("Sheepsizewhenenteringgate", 0.502, 1.005);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_penfront(this: Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_penfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_penfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_holly(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep1(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep1) {
	if (this.setLayoutTexture) this.setLayoutTexture("sheep1", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep2(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep2) {
	if (this.setLayoutTexture) this.setLayoutTexture("sheep2", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetsheep3(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep3) {
	if (this.setLayoutTexture) this.setLayoutTexture("sheep3", -0.499, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelback(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_satchelback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_apple4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_apple3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_apple2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_apple1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelfront(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p07_satchelfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRframe(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRlines(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeLframe(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframellines(this: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p07_appleTarget(this: Ich7_p07_appleTarget) {
	return this;
}
interface Ich7_p07Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p07Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p07Sprite extends Ich7_p07Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p07Text extends Ich7_p07Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p07Polygon extends Array<number> {
}
interface Ich7_p07 {
	readonly sheep: Ich7_p07Array<Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep1|Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep2|Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep3>;
	readonly apple: Ich7_p07Array<Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4|Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3|Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2|Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1>;
	readonly appleTarget: Ich7_p07Array<Ich7_p07_appleTarget>;
	readonly bg: Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_bg;
	readonly gateOpen: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_opengate;
	readonly gateClosed: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_closedgate;
	readonly table: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_taable;
	readonly sheepSizeReference: Ich7_p07_hh_ch7_72dpi_p0708psdAssetSheepsizewhenenteringgate;
	readonly penFront: Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_penfront;
	readonly holly: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_holly;
	readonly satchelBack: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelback;
	readonly satchelFront: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelfront;
	readonly frameRight: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRframe;
	readonly linesRight: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRlines;
	readonly frameLeft: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeLframe;
	readonly linesLeft: Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframellines;
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_bg extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_opengate extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_closedgate extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_taable extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetSheepsizewhenenteringgate extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAsset1chp7_p07_penfront extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_holly extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep1 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep2 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetsheep3 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelback extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple4 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple3 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple2 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_apple1 extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_satchelfront extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRframe extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeRlines extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframeLframe extends Ich7_p07Sprite {
}
interface Ich7_p07_hh_ch7_72dpi_p0708psdAssetchp7_p07_wcframellines extends Ich7_p07Sprite {
}
interface Ich7_p07_appleTarget extends Ich7_p07Container {
}
